export default function Chip() {
    return {
        MuiChip: {
            styleOverrides: {
                root: {
                    userSelect: 'text',
                    cursor: 'text',
                },
                label: {
                    userSelect: 'text',
                },
            }
        }
    };
}